import React, { useEffect } from "react";
import MaterialTable, { MTableHeader } from "material-table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Attribution from "./Attribution";
import "../styles/Table.scss";

type TableConfig = {
  tableHeaders: Record<string, any>[];
  tableData: Record<string, any>[];
};

const tableStyles = {
  cellStyles: {
    padding: "0px",
  } as React.CSSProperties,
};

const Control: React.FC<TableConfig> = ({ tableHeaders, tableData }) => {
  return (
    <div>
      <MaterialTable
        columns={tableHeaders}
        data={tableData}
        options={{
          paging: false,
          search: false,
          padding: "dense",
          showTitle: false,
          thirdSortClick: true,
          rowStyle: tableStyles.cellStyles,
          toolbar: false,
        }}
        components={{
          Header: (props) => {
            return (
              <TableHead>
                <TableRow>
                  <TableCell className="grouped-header" colSpan={1}></TableCell>
                  <TableCell
                    className="grouped-header"
                    colSpan={(tableHeaders.length - 1) / 2}
                    align="left"
                  >
                    Count
                  </TableCell>
                  <TableCell
                    className="grouped-header"
                    colSpan={(tableHeaders.length - 1) / 2}
                    align="left"
                  >
                    Percent
                  </TableCell>
                </TableRow>
                <TableRow>
                  {tableHeaders.map((h, i) => {
                    return (
                      <TableCell align="left" key={i}>
                        {h.title === "All" ? "" : h.title}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            );
          },
        }}
      ></MaterialTable>
      <Attribution></Attribution>
    </div>
  );

  // const classes = useStyles();
};

export default Control;
